module.exports = __webpack_public_path__ + "fonts/Golos-Text_Regular.4356396.woff";